import React from 'react'

// ─────────────────────────────────────────────────────────────────────────────
// EmptyButton , dashed full-width "load more / show archived" button.
//
//   <EmptyButton onClick={…}>Geschlossene Abstimmungen laden (8)</EmptyButton>
// ─────────────────────────────────────────────────────────────────────────────

export function EmptyButton({ onClick, className = '', children }) {
  return (
    <button
      type="button"
      onClick={onClick}
      className={
        'w-full py-3 px-4 rounded-xl border border-dashed border-[#d6d3cb] ' +
        'text-[#6b6862] text-[13px] font-medium ' +
        'hover:border-[#e85d1f] hover:text-[#e85d1f] hover:bg-[#fff1e8] transition-all ' +
        (className || '')
      }
    >
      {children}
    </button>
  )
}
